import { createSelector } from 'reselect';
import { getTr } from '../../../Report/Report.selectors';
import { getLastDays } from '../helpers';
import ReportComponent from '../../../../utils/ReportComponent/ReportComponent';
import config from '../../../../config';

const statistics = (state) => state.dashboard.last.data || [];
const parameters = (state) => state.dashboard.last.parameters || {};

const reportUtils = ReportComponent.utils;

const buildZeroRow = (() => {
    let cachedKeys = null;
    return (groupByValue) => {
        if (!cachedKeys) cachedKeys = reportUtils.getKeysMetric();
        const row = { GroupBy: groupByValue };
        for (const key of cachedKeys) {
            if (key === 'GroupBy') continue;
            row[key] = 0;
        }
        return row;
    };
})();

export const mainSelector = createSelector(
    statistics,
    parameters,
    (statisticsData = [], params = {}) => {
        let data = '';
        const lastDays = getLastDays();
        lastDays.push(config.reportKeyTotal);
        lastDays.forEach((keyDay) => {
            const found = statisticsData.find((item) => item.GroupBy === keyDay);
            const row = found ? { ...found } : buildZeroRow(keyDay);
            const isTotal = keyDay === config.reportKeyTotal;
            data += getTr(row, params, isTotal);
        });
        return data;
    }
);

export const getHeaderName = createSelector(parameters, (params = {}) => {
    reportUtils.setKeyGroupBy(params.group_by);
    const headerNames = reportUtils.getMultiLevelHeaderNames();
    const metrics = reportUtils.getStrMetric();
    const visibleKeysMetric = reportUtils.getKeysMetric(metrics);
    reportUtils.updateVisible(headerNames, visibleKeysMetric);
    return headerNames;
});

export const getMetrics = createSelector(() => reportUtils.getStrMetric());
